import { Permissions } from '@efficiently/models';

import { PAGES_ROUTES } from '@efficiently/client-core-routing';
import { AppPageLabelsEnum } from '@efficiently/client-util-classes';

import type { PlatformAdminTabDefinition } from '@ds/shared/models/platform-admin-tab-definition.model';
import { ITEM_CATALOG_LIST_ROUTES } from '@ds/shared/modules/item-catalog/item-catalog-list/item-catalog-list-routing.const';

/** The user-menu entry's label, and the name of the group of pages below it. */
export const PLATFORM_ADMIN_LABEL = 'Platform Administrator';

/**
 * The four sub-tabs, in the order the strip renders them left to right.
 *
 * Admin Console is deliberately NOT here. It moved into the user menu under `ORG` in EFF-26081
 * and stays there, gated on `AdminConsoleTabView` (EFF-24841 AC 4) — the mock that shows it as a
 * fifth tab predates that move.
 *
 * This is the one table for the group. The strip, the user-menu entry (both its visibility and
 * where it navigates) and the child routes' own paths and guards all come from here, so a page
 * can never be offered by one and refused by another.
 */
export const PLATFORM_ADMIN_TAB_DEFINITIONS: readonly PlatformAdminTabDefinition[] = [
	{
		id: 'catalog',
		label: AppPageLabelsEnum.catalog,
		path: PAGES_ROUTES.ITEM_CATALOG.path,
		routerLink: [ITEM_CATALOG_LIST_ROUTES.ITEMS.fullPath()],
		routePermissions: [Permissions.ItemCatalogTabView],
		tabPermission: Permissions.ItemCatalogTabView,
	},
	{
		id: 'csv-export',
		label: AppPageLabelsEnum.csvExports,
		path: PAGES_ROUTES.CSV_EXPORT.path,
		routerLink: [PAGES_ROUTES.CSV_EXPORT.fullPath()],
		routePermissions: [Permissions.ItemCatalogManage],
		tabPermission: Permissions.ItemCatalogManage,
	},
	{
		id: 'manage-catalog',
		label: AppPageLabelsEnum.manageCatalog,
		path: PAGES_ROUTES.MANAGE_CATALOG.path,
		routerLink: [PAGES_ROUTES.MANAGE_CATALOG.fullPath()],
		routePermissions: [Permissions.ItemCatalogManage],
		tabPermission: Permissions.ItemCatalogManage,
	},
	{
		id: 'orgs',
		label: AppPageLabelsEnum.organizations,
		path: PAGES_ROUTES.ORGS.path,
		routerLink: [PAGES_ROUTES.ORGS.fullPath()],
		routePermissions: [Permissions.OrgView],
		tabPermission: Permissions.OrgEdit,
	},
];
